import { useTheme } from "@mui/material";
import React from "react";
import {
  StyledOngletName,
  StyledGrid,
  StyledHeader,
  StyledContainer,
  StyledColumnName,
  // StyledData,
  StyledCell,
  StyledDataVide,
  StyledDataNonVide,
} from "./styles";

const getPourcentage = (element, global) => {
  const globalTot = global.vide + global.nonVide;
  return globalTot ? element / globalTot : 0;
};

const DashboardTable = ({ dashboardBytab, tabsColumnsMapNamed }) => {
  const theme = useTheme();
  return (
    <StyledContainer>
      <StyledGrid theme={theme}>
        <StyledCell>
          <StyledOngletName theme={theme}>
            {dashboardBytab.tab.name}
          </StyledOngletName>
        </StyledCell>
        <StyledCell>
          <StyledHeader theme={theme}>Fait</StyledHeader>
        </StyledCell>
        <StyledCell>
          <StyledHeader theme={theme}>Non-Fait</StyledHeader>
        </StyledCell>
        {Object.keys(dashboardBytab.resultats).map((column, i) => {
          const videData = getPourcentage(
            dashboardBytab.resultats[column]?.vide,
            dashboardBytab.resultats[column]
          );
          const NotVideData = getPourcentage(
            dashboardBytab.resultats[column]?.nonVide,
            dashboardBytab.resultats[column]
          );
          return (
            <React.Fragment key={i}>
              <StyledCell>
                <StyledColumnName theme={theme}>
                  {tabsColumnsMapNamed[column].name}
                </StyledColumnName>
              </StyledCell>
              <StyledCell>
                <StyledDataVide theme={theme} data={videData}>
                  {dashboardBytab.resultats[column]?.vide}
                </StyledDataVide>
              </StyledCell>
              <StyledCell>
                <StyledDataNonVide theme={theme} data={NotVideData}>
                  {dashboardBytab.resultats[column]?.nonVide}
                </StyledDataNonVide>
              </StyledCell>
            </React.Fragment>
          );
        })}
      </StyledGrid>
    </StyledContainer>
  );
};

export default DashboardTable;
